<template>
    <div class="home" :style="`height:${height}px;`">
        <transition name="fade">
            <div class="widget-wrap" v-show="show">
                <b-container>
                    <b-row>
                        <b-col class="pt-2">
                            <Chat v-if="!$route.query.loggedInStatus" />
                            <Login v-else />
                            <p></p>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </transition>
    </div>
</template>

<script>
import Login from "../components/Login";
import Chat from "../components/Chat";
import { mapGetters } from "vuex";
export default {
    name: "Home",
    data: () => ({
        show: true,
        height: window.innerHeight,
        ecom_params: {},
    }),
    computed: {
        ...mapGetters({
            loggedOut: "loggedOut",
        })
    },
    async mounted() {
        this.ecom_params = this.$route.query
        if(this.ecom_params.liveChatReset == 'true' && !this.loggedOut) this.$store.dispatch('resetState')
    },
    components: {
        Login,
        Chat
    },
}
</script>

<style scoped>
.dock {
    background-color: #2f3b84;
    border: 1px solid #2f3b84;
    display: inline-block;
    cursor: pointer;
    color: #fff;
    font-family: Arial;
    font-size: 15px;
    padding: 12px 0px;
    text-decoration: none;
    text-align: center;
    width: 320px;
    bottom: 0px;
    right: 0px;
    position: fixed;
}

.dock:hover {
    background-color: #434e90;
    border: 1px solid #434e90;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
					/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
}

.widget-wrap {
    height: 100%;
    background: #fff;
    right: 0px;
}
.navbar-text {
    color: rgba(255, 255, 255, 1) !important;
}
</style>
